const Contact = (props) => {
    return ( 
        <div className="contact">
            <strong><p> Contact us</p></strong>
            <div>+23481234567</div>
            <div>devsprimesq007@gmail.com</div>
            <div> 7, Asajon way,Sangotedo Ajah Lagos</div>
        </div>
     );
} 
export default Contact;
